import controller from './org-structure-labels.controller';

const template = require('./org-structure-labels.html');

export default {
    bindings: {
        labels: '<',
        canUpdate: '<',
        onSave: '&' // Called with { key, value }; an empty value removes the label
    },
    template,
    controller
};
